import { BaseSchema, ModelSchema } from './helpers'
import { PageSchema } from './PageSchema'
import { CommentSchema } from './CommentSchema'

@ModelSchema({
  name: 'comment_thread',
  description: 'Owned by a page, contains comments',
  version: 0,
  required: ['page_id'],
  associations: () => [
    { type: 'belongsTo', model: PageSchema, key: 'page', foreignKey: 'page_id' },
    { type: 'hasMany', model: CommentSchema, key: 'comments' },
  ],
})
export class CommentThreadSchema extends BaseSchema {
  page_id: string
}
